/* eslint-disable @typescript-eslint/no-explicit-any */
import { filter, find, last, without } from 'es-toolkit/compat';
import Mousetrap from 'mousetrap';

let clickEventStack: any[] = [];
let keyUpEventStack: any[] = [];

const triggerTopClickEvent = (event: MouseEvent) => {
  const handler = last(clickEventStack);
  if (handler && typeof handler.callback === 'function') {
    handler.callback(event);
  }
};

const triggerTopKeyUpEvent = (event: KeyboardEvent) => {
  const callback = last(keyUpEventStack);
  callback(event);
};

function removeClickHandler(stack: any, callback: any, key: any) {
  return filter(clickEventStack, (handler: any) => {
    return handler && !(handler.callback === callback && handler.key === key);
  });
}

/*
  Global click events that have a key are considered "unique" and will fire
  and remove other events with the same key before adding themselves to the
  stack. This is currently being used to make sure only one popover
  (BasicDropdown, DatePicker, HelpMenu) is open at a time.
  */
export function addGlobalClickEvent(callback: any, key?: any) {
  const root = document.getElementById('Root');
  if (key) {
    const existingHandler = find(clickEventStack, (handler: any) => {
      return handler.key === key;
    });

    if (existingHandler) {
      existingHandler.callback();
      clickEventStack = removeClickHandler(clickEventStack, callback, key);
    }
  }

  clickEventStack.push({
    callback,
    key,
  });

  if (clickEventStack.length === 1 && root) {
    root.addEventListener('click', triggerTopClickEvent);
    // document.addEventListener('touchstart', triggerTopClickEvent, false);
  }
}

export function removeGlobalClickEvent(callback: any, key?: any) {
  const root = document.getElementById('Root');
  clickEventStack = removeClickHandler(clickEventStack, callback, key);

  if (clickEventStack.length === 0 && root) {
    root.removeEventListener('click', triggerTopClickEvent);
    // document.removeEventListener('touchstart', triggerTopClickEvent);
  }
}

export function addGlobalKeyUpEvent(callback: any) {
  const root = document.getElementById('Root');
  keyUpEventStack.push(callback);
  if (keyUpEventStack.length === 1 && root) {
    root.addEventListener('keyup', triggerTopKeyUpEvent, false);
  }
}

export function removeGlobalKeyUpEvent(callback: any) {
  const root = document.getElementById('Root');
  keyUpEventStack = without(keyUpEventStack, callback);
  if (keyUpEventStack.length === 0 && root) {
    root.removeEventListener('keyup', triggerTopKeyUpEvent);
  }
}

export let shiftPressed = false;
export let altPressed = false;
if (BROWSER) {
  Mousetrap.bind(
    'alt',
    () => {
      altPressed = true;
    },
    'keydown'
  );
  Mousetrap.bind(
    'alt',
    () => {
      altPressed = false;
    },
    'keyup'
  );
  Mousetrap.bind(
    'shift',
    () => {
      shiftPressed = true;
    },
    'keydown'
  );
  Mousetrap.bind(
    'shift',
    () => {
      shiftPressed = false;
    },
    'keyup'
  );
}
